import { RacwaStandardPageTemplateProps, theme } from "@racwa/react-components";
import { useLocation } from "react-router-dom";
import { PreFormPageHeading, standardPageRoutes } from "../../routing/routes.config";
import usePage from "../usePage";

export const useStandardPage = (): RacwaStandardPageTemplateProps => {
  const commonPageProps = usePage();
  const location = useLocation();

  const currentUtilityRoute = standardPageRoutes.find(
    (route) => route.path.toLowerCase() === location.pathname.toLowerCase(),
  );

  const heading = currentUtilityRoute?.heading ?? "";

  const useYellowHeading = heading === PreFormPageHeading.BeforeYouStart;

  return {
    heading,
    bannerTextColour: useYellowHeading ? theme.palette.primary.main : theme.palette.common.white,
    navBreadcrumbProps: commonPageProps.responsiveHeaderProps?.NavBreadcrumbsProps,
    ...commonPageProps,
  };
};

export default useStandardPage;
